module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00596.ac9cf62a.jpg";